import React from "react";
import { footerLinks } from "../mock";

const Footer = () => {
  return (
    <footer className="w-full px-margin-mobile md:px-margin-desktop py-narrative-gap flex flex-col md:flex-row justify-between items-center gap-8 bg-background-ivory border-t border-hairline-beige">
      <div className="flex flex-col items-center md:items-start">
        <span className="font-cormorant text-[26px] leading-none tracking-tight text-brand-ink">
          The Kitchen Art Co.<sup className="text-[0.5em] align-super tracking-normal ml-0.5">&reg;</sup>
        </span>
        <span className="font-inter text-[10px] tracking-[0.2em] uppercase text-brand-secondary mt-2">
          Creating Experiences Beyond Catering
        </span>
      </div>
      <div className="flex flex-wrap justify-center gap-6">
        {footerLinks.map((link) => (
          <a
            key={link.label}
            href={link.href}
            className="font-inter text-label-sm tracking-widest uppercase text-deep-taupe hover:text-bright-gold-on-dark transition-colors duration-300"
          >
            {link.label}
          </a>
        ))}
      </div>
      <div className="font-inter text-label-sm tracking-widest uppercase text-deep-taupe text-center md:text-right">
        {"\u00A9"} 2026 The Kitchen Art Co. All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
